import { IBaseLineDx } from "./BaseLineDx";

export interface IStageDx {
  id?: string;
  name: string;
  description: string;
  createdDate: Date;
  baseline?: IBaseLineDx;
  projectId: number;
  author: string;
  tag?: string;
  notificationsPolicy?: string;
  color: string;
}

export default class StageDx {
  private id?: string;
  private name: string;
  private description: string;
  private createdDate: Date;
  private baseline?: IBaseLineDx;
  private projectId: number;
  private author: string;
  private tag?: string;
  private notificationsPolicy?: string;
  private color: string;

  constructor(dto: IStageDx) {
    Object.assign(this, dto);
  }

  get getId(): string {
    return this.id;
  }

  set setId(value: string) {
    this.id = value;
  }

  get getName(): string {
    return this.name;
  }

  set setName(value: string) {
    this.name = value;
  }

  get getDescription(): string {
    return this.description;
  }

  set setDescription(value: string) {
    this.description = value;
  }

  get getCreatedDate(): Date {
    return this.createdDate;
  }

  set setCreatedDate(value: Date) {
    this.createdDate = value;
  }

  get getBaseline(): IBaseLineDx {
    return this.baseline;
  }

  set setBaseline(value: IBaseLineDx) {
    this.baseline = value;
  }

  get getProjectId(): number {
    return this.projectId;
  }

  set setProjectId(value: number) {
    this.projectId = value;
  }

  get getAuthor(): string {
    return this.author;
  }

  set setAuthor(value: string) {
    this.author = value;
  }

  get getTag(): string {
    return this.tag;
  }

  set setTag(value: string) {
    this.tag = value;
  }

  get getNotificationsPolicy(): string {
    return this.notificationsPolicy;
  }

  set setNotificationsPolicy(value: string) {
    this.notificationsPolicy = value;
  }

  get getColor(): string {
    return this.color;
  }

  set setColor(value: string) {
    this.color = value;
  }
}
